import React from 'react'
import ReactWOW from 'react-wow'
import { Link } from 'gatsby'
import bannerImg from '../../assets/images/banner-img1.png'
import homeImg from '../../assets/images/home-image.jpg'

const Banner = () => {
    return (
        <div className="ptb-100 bg-fafafb">
            <div id="background"></div>
            <div className="it-services-banner">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12 offset-lg-6 card" style={{'backgroundColor': 'rgba(255,255,255,0.5)', 'borderRadius': '1em'}}>
                            <div className="main-banner-content">
                                <ReactWOW delay='.1s' animation='fadeInLeft'>
                                    <h1 className="main-title">Asociación Mexicana de Autoridades de Movilidad</h1>
                                </ReactWOW>

                                <ReactWOW delay='.1s' animation='fadeInLeft'>
                                    <p className="main-subtitle">La Asociación Mexicana de Autoridades de Movilidad (AMAM) es una iniciativa de gobiernos estatales y municipales, apoyados por el Instituto de Recursos Mundiales México A.C. (WRI México)  ) y la Asociación Nacional de Productores de Autobuses, Camiones y Tractocamiones, A.C. (ANPACT), que desde el 25 de enero de 2017 trabaja para mejorar la movilidad y el transporte público en México, mediante el trabajo conjunto entre autoridades municipales y estatales, el fortalecimiento y la generación de políticas públicas locales y federales.</p>
                                </ReactWOW>

                                <ReactWOW delay='.1s' animation='fadeInRight'>
                                    <div className="btn-box">
                                        <Link to="/newsletters" className="default-btn">
                                            <i className="flaticon-right"></i>
                                            Newsletters <span></span>
                                        </Link>
                                    </div>
                                </ReactWOW>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Banner
